// extracted by css-extract-rspack-plugin
export default {"joinedNote":"FormFields__joinedNote--SJMIY","main_grid":"FormFields__main_grid--nA1Dt"};